<template>
  <Modal name="DELETE_VENDOR_MODAL" :title="title" actions>
    <template v-slot:body>
      <p class="mb-1">{{ $t('vendors.hints.delete') }}</p>
      <v-card class="pa-5 mt-5 grey lighten-3" outlined>
        <v-progress-linear v-if="isVendorLoading" indeterminate />
        <span v-else>
          <h6 class="text-uppercase grey--text">
            {{ $t('vendors.label.title') }}
          </h6>
          <p class="body-2 mb-0">
            {{ vendor.name }}
          </p>
          <span class="caption grey--text text--darken-1">
            {{ vendor.document }}
          </span>
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isVendorLoading"
        class="mr-5"
        large
        text
      >
        {{ $t('vendors.action.cancel') }}
      </v-btn>

      <v-btn
        @click="removeVendor(vendor.id)"
        :loading="isVendorLoading"
        class="red"
        large
        dark
        text
      >
        {{ $t('vendors.action.delete') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import Modal from '@/components/app/Modal'

export default {
  name: 'VendorsDelete',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['vendor', 'isVendorLoading']),
  },

  data() {
    return {
      title: this.$t('vendors.action.delete'),
    }
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['removeVendor']),
  },
}
</script>
